import { API_URL } from '../../../app-config/constants';
import type { ViewAs } from '../../react/features/YourFeedback/types';
import { get } from '../request';

const BASE_URL = `${API_URL}/unified-feedback/details`;

export type FeedbackSummary = {
    summary: string;
};

getById.operation = 'READ';
getById.idFrom = 'ARGS';
export function getById(id: string): Promise<FeedbackSummary> {
    return get(`${BASE_URL}/${id}/summary`);
}

getViewedAs.operation = 'READ';
getViewedAs.idFrom = 'ARGS';
export function getViewedAs(id: string, view: ViewAs): Promise<FeedbackSummary> {
    return get(`${BASE_URL}/${id}/view-as/${view}/summary`);
}
